import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell, ChevronDown, Search, WalletCards } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function UserHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = user?.name?.charAt(0)?.toUpperCase() || "U";
  const logoUrl = `${process.env.PUBLIC_URL}/logo.png`;

  function handleLogout() {
    logout();
    navigate("/login");
  }

  return (
    <header className="user-header">
      <div className="user-header-brand">
        <img src={logoUrl} alt="Lucky Pool logo" className="dashboard-header-logo" />
        {/* <span>Lucky Pool</span> */}
      </div>
      <div className="user-search">
        <Search size={18} />
        <input type="search" placeholder="Search pools, draws or tickets..." />
      </div>
      <div className="system-live user-live"><i /> System Live</div>
      <div className="header-actions">
        <span className="balance"><WalletCards size={15} /> $1,240.50</span>
        <button className="icon-button" aria-label="Notifications"><Bell size={18} /><i /></button>
        <details className="profile-menu">
          <summary aria-label="Open profile menu">
            <span className="avatar">{initials}</span>
            <ChevronDown size={15} />
          </summary>
          <div className="profile-dropdown">
            <strong>{user?.name || "User"}</strong>
            <span>{user?.email || ""}</span>
            <Link to="/dashboard/profile">Profile Settings</Link>
            <Link to="/dashboard/payments">Payment Methods</Link>
            <Link to="/dashboard/subscription">Subscription</Link>
            <button className="danger" onClick={handleLogout} style={{ background: "none", border: 0, cursor: "pointer", textAlign: "left", padding: "9px 10px", borderRadius: 6, color: "rgba(255,180,171,.86)", fontSize: 13 }}>
              Logout
            </button>
          </div>
        </details>
      </div>
    </header>
  );
}
